export default "/images/8b4a96f0a21f6a713f70198755f5ff96.avif";